const angular = require('angular');

const TrackMyOrderService = require('./trackmyorder.service');
const { trackMyOrderComponentDefinition } = require('./track-my-order.component');
const { trackMyOrderInformationComponentDefinition } = require('./track-my-order-information.component');
const { trackMyOrderProcessComponentDefinition } = require('./track-my-order-process.component');
const { trackMyOrderProcessNodeComponentDefinition } = require('./track-my-order-process-node.component');
const { trackMyOrderGuestFormComponentDefinition } = require('./trackmyorder-guest-form.component');

angular.module('wowApp.shop')
    .service('TrackMyOrderService', TrackMyOrderService)
    .component('wowTrackMyOrder', trackMyOrderComponentDefinition)
    .component('wowTrackMyOrderInformation', trackMyOrderInformationComponentDefinition)
    .component('wowTrackMyOrderProcess', trackMyOrderProcessComponentDefinition)
    .component('wowTrackMyOrderProcessNode', trackMyOrderProcessNodeComponentDefinition)
    .component('wowTrackmyorderGuestForm', trackMyOrderGuestFormComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/trackmyorder/index.js